import React from "react";
import AppointmentModule  from "./appointments";
const Appointments = (props) => {
  return (
    <><AppointmentModule /></>
  );
};
export default Appointments;
